import React, { useMemo } from "react";

import { TicketAndPassesForm } from "Bands/components";
import { useBandContext } from "Bands/contexts";
import { IGuestlistTicketAndPassParams } from "Bands/types";
import { copy } from "shared/assets";
import { Modal } from "shared/components";
import { IAPIState, IFormButtons } from "shared/types";

const editCopy = copy.guestlistBlock.ticketAndPasses.edit;

interface EditTicketAndPassModalProps {
  ticketAndPass?: IGuestlistTicketAndPassParams;
  apiMeta?: { status: IAPIState; error?: any };
  error?: string | boolean;
  handleEdit: (
    ticketAndPass: IGuestlistTicketAndPassParams,
    id: string
  ) => void;
  handleClose: () => void;
}

export const EditTicketAndPassModal: React.FC<EditTicketAndPassModalProps> = ({
  ticketAndPass,
  handleClose,
  handleEdit,
  apiMeta,
  error,
}) => {
  const { ticketAndPassTypes } = useBandContext();

  const onSubmit = (newTicketAndPass: IGuestlistTicketAndPassParams) => {
    if (!ticketAndPass?.id) return;

    handleEdit(newTicketAndPass, ticketAndPass?.id);
  };

  const buttons: IFormButtons = useMemo(
    () => ({
      secondary: {
        onClick: handleClose,
      },
    }),
    [handleClose]
  );

  return (
    <Modal
      title={editCopy.title}
      handleClose={handleClose}
      data-testid="edit_ticket_type_modal"
    >
      <TicketAndPassesForm
        disableType
        ticketAndPassTypes={ticketAndPassTypes}
        handleSubmit={onSubmit}
        buttons={buttons}
        defaultValues={ticketAndPass as IGuestlistTicketAndPassParams}
        submitMode="isDirty"
        apiStatus={apiMeta?.status}
        apiError={apiMeta?.error}
        error={error}
      />
    </Modal>
  );
};
